import declare from "dojo/_base/declare";
import Ref from "csi/heading/Ref";
import _StyleAndColorwayMixin from "./_StyleAndColorwayMixin";

const OptionVersionColorway = declare([Ref, _StyleAndColorwayMixin], {
});

export = OptionVersionColorway;